var def_promt;
export const setDefPromt = (e) => {
  def_promt = e;
  return def_promt;
};
export const getDefPromt = () => {
  return def_promt;
};

export const isIos = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua);
};

export const isFirefox = () => {
  return /firefox/i.test(window.navigator.userAgent);
};

export const getCountryFlagByCioc = (countryCode = "") => {
  if (!countryCode) return "";
  const flagUrl = `https://s3.ap-southeast-1.amazonaws.com/visaero.assets/flags/${countryCode?.toLowerCase()}.png`;
  return flagUrl;
};


export function maskEmail(email) {
  if (!email.includes("@")) return email; // fallback if no @ present

  const [user, domain] = email.split("@");

  if (user.length <= 2) {
    // If very short username, keep first char and mask rest
    return user[0] + "*".repeat(user.length - 1) + "@" + domain;
  }

  // Keep first 2 chars, mask the rest
  return user.slice(0, 2) + "*".repeat(user.length - 2) + "@" + domain;
}